/** Digits-only form of a phone string for allowlist matching. */
export function phoneDigits(raw) {
  return String(raw || '').replace(/\D/g, '');
}

/** US-style display for a number object from /numbers. */
export function formatCallerIdOption(number) {
  const e164 = (number && number.phone_number) || '';
  const digits = String(e164).replace(/\D/g, '');
  if (digits.length === 11 && digits.startsWith('1')) {
    return `(${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7)}`;
  }
  if (digits.length === 10) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  }
  return e164;
}

/**
 * Dialed-line label for the incoming banner — only when `to` is one of this
 * user's allowed lines from /numbers. Never show a sibling org DID the
 * session cannot use.
 */
export function permittedIncomingLineLabel(toNumber, phoneNumbers) {
  const toDigits = phoneDigits(toNumber);
  if (!toDigits || !Array.isArray(phoneNumbers) || !phoneNumbers.length) return null;
  const match = phoneNumbers.find((n) => {
    const d = phoneDigits(n.phone_number);
    return d && (d === toDigits || d.endsWith(toDigits) || toDigits.endsWith(d));
  });
  if (!match) return null;
  return formatCallerIdOption(match);
}
